//const UrlPrefix = '';
const UrlPrefix = '/namaz-time';
export default UrlPrefix;